import './polyfill';
import './public-path';

import { createBrowserHistory } from 'history';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';

import { ApiClientProvider } from '@travel/api-client';
import { setReactUpgradeMonitoring } from '@travel/tracker'; //TODO: remove this when we finish React 19 migration
import { getDeviceType } from '@travel/traveler-core/utils';
import UIComponentContext from '@travel/ui/contexts';

import { createApiClient } from 'favoriteList/core/httpClient';
import commonErrorHandler from 'favoriteList/core/httpClient/commonErrorHandler';
import requestInterceptor from 'favoriteList/core/httpClient/requestInterceptor';
import responseInterceptor from 'favoriteList/core/httpClient/responseInterceptor';
import universalRouter from 'favoriteList/core/universalRouter';
// import initTranslation from 'favoriteList/core/translate/init';
// import { getSsrDeviceType } from 'favoriteList/store/userAgent/selectors';
import { Link } from 'favoriteList/core/universalRouter/Link';
import Router from 'favoriteList/core/universalRouter/Router';
import configureStore from 'favoriteList/store';

setReactUpgradeMonitoring(); //TODO: remove this when we finish React 19 migration
const apiClient = createApiClient();

const history = createBrowserHistory({
  basename: window.PRELOADED_STATE.router.baseUrl,
});
const ssrDeviceType = getDeviceType(window.PRELOADED_STATE.userAgent);
const store = configureStore(window.PRELOADED_STATE, history, undefined, undefined, apiClient);

apiClient.setRequestInterceptor(requestInterceptor(store));
apiClient.setResponseInterceptor(responseInterceptor(store));
apiClient.setCommonErrorHandler(commonErrorHandler(store));

// initialize labels
// initTranslation(store.getState().labels.dictionary || {});

// Initialize the app
(async () => {
  const router = universalRouter({ store });
  const children = await router.resolve({
    ...history.location,
    skipResolver: true,
  });

  hydrateRoot(
    document.getElementById('root') as any,
    <HelmetProvider>
      <UIComponentContext.Provider
        value={{
          ssrDeviceType: ssrDeviceType,
          LinkComponent: ({ href, children, ...rest }) => (
            <Link to={href || ''} {...rest}>
              {children}
            </Link>
          ),
        }}
      >
        <ApiClientProvider apiClient={apiClient}>
          <ReduxProvider store={store}>
            <Router history={history} router={router}>
              {children}
            </Router>
          </ReduxProvider>
        </ApiClientProvider>
      </UIComponentContext.Provider>
    </HelmetProvider>,
  );
})();
